export default __webpack_public_path__ + "static/strives-2284f1587a883ed7181432c078612435.webp";